export interface CustomStockProtectionRequest {
    processNumber?:string,
    productCode?:string,
    customerNumber?:string,
    scenario?:string
}

export interface CustomStockProtectionOverview {
    processNumber?:string,
    productCode?:string,
    productTitle?:string,
    productUrl?:string,
    deliveryPeriodFrom?:Date,
    deliveryPeriodTo?:Date,
    reportingPeriodFrom?:Date,
    reportingPeriodTo?:Date,
    formattedDeliveryPeriodFrom?:string,
    formattedDeliveryPeriodTo?:string,
    formattedReportingPeriodFrom?:string,
    formattedReportingPeriodTo?:string,
    state?:string,
    inactive?:string,
    summary?:string,
    value?:string,
    currency?:string
}

export interface CustomStockProtectionOverviewList {
    responses?: CustomStockProtectionOverview[]
}

export interface SerialNoStatusRequest {
    processNumber?:string,
    accountNumber?:string
}

export interface SerialNoStatusResponse {
    serialNumber?:string,
    statusCode?:string,
    statusText?:string,
    statusDeliveryCode?:string
}

export interface SerialNoStatusResponseList {
    responses?: SerialNoStatusResponse[]
}

export interface UpdateSerialNosRequest {
    serialNumbers?: String[]
}

export interface AddSerialNosRequest {
    serialNumbers?: String[],
    articleNumbers?:string
}

export enum CustomStockProtectionScenarioOptions {
    ALL = " ",
    CURRENT_UNFINISHED = "1",
    COMPLETED_UNRECORDED = "2"
}

export enum CustomStockProtectionSortOptions {
    processNumber,
    state,
    productCode,
    productTitle,
    deliveryPeriodFrom,
    deliveryPeriodTo,
    reportingPeriodFrom,
    reportingPeriodTo,
    value,
    currency
}

export interface CustomFileUploadResponse{
    hint?:string,
    status?:string
}